import { useEffect } from 'react';
import { lazyLoadSentry } from '@/_helpers/boundaryHelpers';

/**
 * Report an error boundary exception to Sentry when the app is online.
 *
 * This hook is intended for use inside error boundary fallback components. It lazily loads the Sentry React SDK to
 * avoid eagerly bundling Sentry, and captures the provided error only when the client is not offline.
 *
 * @param error - The error thrown by the error boundary.
 * @param isOffline - Whether the client is currently offline.
 */
export function useReportBoundaryErrorToSentry(error: unknown, isOffline: boolean): void {
  useEffect(() => {
    if (isOffline) return;

    (async () => {
      try {
        const Sentry = await lazyLoadSentry();
        Sentry.captureException(error);
      } catch {
        // swallow reporting errors
      }
    })();
  }, [error, isOffline]);
}